/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconHome = createReactComponent("home", "IconHome", [
  ["path", { d: "M5 12l-2 0l9 -9l9 9l-2 0", key: "svg-0" }],
  ["path", { d: "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7", key: "svg-1" }],
  ["path", { d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6", key: "svg-2" }]
]);

export { IconHome as default };
//# sourceMappingURL=IconHome.js.map
